// extracted by mini-css-extract-plugin
module.exports = {"Container":"BlogAuthor_Container__3mlyn","Image":"BlogAuthor_Image__3A0Yw","InfoColumn":"BlogAuthor_InfoColumn__agMXb"};